import {
    iAuth,
    IdentityProvider,
    iTenant,
    iTenantContext,
    iTenants,
    iTenantsResponse,
    iToken,
} from "../../interfaces/auth";
import {
    getElevateValue,
    getLocalValue,
    getSessionValue,
    saveLocalValue,
    saveSessionValue,
} from "../../utilities/localStore/calls";
import { ConstructPermissions } from "../../utilities/permissions";

import { Buffer } from "buffer";
import { GetUserProfileData } from "../../components/UserProfile/tenantApiCall";
import { GetMailboxPermissions, Permissions as iPermissions } from "../../interfaces/Permissions";
import { getAllPreferences } from "../../interfaces/userPrefence";
import { iTenantConfiguration, setConfiguration } from "../../state/configSlice";
import { setPermissions } from "../../state/PermissionSlice";
import store from "../../state/store";
import { iUser, setUser, setUserPreferences } from "../../state/userSlice";
import { callApi, iRequest } from "../../utilities/apiCall";
import { GetJwtClaim } from "../../utilities/jwt";
import { createAuthWorker } from "../../workerProcesses/authWorkerFactory";
import { getLastTouched, saveLastTouched } from "../LastTouched/misc";

export const awsConfig = {
    ClientId: "",
    Url: "",
    RedirectUrl: "",
};

export async function getTenants(): Promise<iTenantsResponse> {
    const crypto = getLocalValue<iAuth>("auth");
    const hHeaders = new Headers();
    hHeaders.append("Accept", "application/json");
    hHeaders.append("Authorization", "Bearer " + crypto?.token.id_token);
    let fetchOptions: any = {};
    fetchOptions.method = "GET";
    fetchOptions.headers = hHeaders;
    let response = await fetch(getSTSUrl() + "Tenants", fetchOptions);
    if (response.status == 401) {
        throw new Error("401");
    }
    let tenantsResponse: iTenantsResponse = await response.json();
    updateRecentTenants(tenantsResponse.tenants);
    return tenantsResponse;
}

export async function exchangeIdpToken(crypto: iAuth, tenant: string): Promise<iTenantContext> {
    let elevate = getElevateValue() == true ? "?elevate=true" : "";
    const hHeaders = new Headers();
    hHeaders.append("Accept", "application/json");
    hHeaders.append("Authorization", "Bearer " + crypto.token.id_token);
    var fetchOptions: any = {};
    fetchOptions.method = "GET";
    fetchOptions.headers = hHeaders;
    const response = await fetch(getSTSUrl() + "Tenants/" + tenant + "/Token" + elevate, fetchOptions);
    if (response.status == 403) {
        throw new Error("403"); //cant access tenant so refresh the tokens
    } else if (response.status == 401) {
        throw new Error("401"); // auth credentionals failed , logout
    }
    return response.json();
}

export async function UpdateConfiguration() {
    let request: iRequest = {
        url: "Config",
        method: "GET",
        headers: [],
        body: "",
        responseType: "json",
    };

    const response: iTenantConfiguration = await callApi(request);

    store.dispatch(setConfiguration(response));
}

export async function getToken(crypto: iAuth): Promise<any> {
    const tokenEndpoint = new URL(crypto.tokenUrl);
    tokenEndpoint.searchParams.append("grant_type", "authorization_code");
    tokenEndpoint.searchParams.append("client_id", crypto.clientId!);
    tokenEndpoint.searchParams.append("code_verifier", crypto.verifier);
    tokenEndpoint.searchParams.append("code", crypto.code);
    tokenEndpoint.searchParams.append("redirect_uri", window.location.origin + "/auth/callback");

    const hHeaders = new Headers();
    hHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    hHeaders.append("Accept", "application/json");
    var fetchOptions: any = {};
    fetchOptions.method = "POST";
    fetchOptions.headers = hHeaders;
    fetchOptions.body = tokenEndpoint.searchParams;

    try {
        const response = await fetch(crypto.tokenUrl, fetchOptions)
            .then(data => {
                if (data.status == 204) {
                    return "No Content";
                } else {
                    return data.json();
                }
            })
            .catch(err => {
                saveLocalValue("error-logut-4", "tokenMange.ts line 111" + err);
                return err;
            });

        return response;
    } catch (err) {
        alert(err);
    }
}

export async function postToS3(crypto: iAuth): Promise<any> {}

export async function refreshIDPToken(): Promise<any> {
    try {
        const crypto = getLocalValue<iAuth>("auth");
        if (!crypto) throw new Error("Failed to refresh");
        const tokenEndpoint = new URL(crypto.tokenUrl);

        tokenEndpoint.searchParams.append("grant_type", "refresh_token");
        tokenEndpoint.searchParams.append("refresh_token", crypto.token.refresh_token);
        const hHeaders = new Headers();
        hHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        hHeaders.append("Accept", "application/json");
        var fetchOptions: any = {};
        fetchOptions.method = "POST";
        fetchOptions.headers = hHeaders;
        fetchOptions.body = tokenEndpoint.searchParams;

        let response = await fetch(crypto.tokenUrl, fetchOptions);
        if (response.status != 200) {
            throw new Error("error" + response.status + " - " + response.statusText);
        }
        if (crypto !== null) {
            const responseT = await response.json();
            localStorage.setItem(
                "error-logout-token",
                "TokenManager.ts - line 144 " + responseT + " - " + new Date().toString(),
            );
            crypto.token = responseT;
            saveLocalValue("auth", crypto);
        }
    } catch (err) {
        //we need to remove this line when problem resolved
        localStorage.setItem("error-logout-refreshtoken", "refreshIDPToken line 150 " + " - " + new Date().toString());
        logout();
        window.location.href = window.location.origin;
    }
}

export async function RefreshItegratedGalToken(): Promise<any> {
    const crypto = getLocalValue<iAuth>("auth");
    if (!crypto) {
        return;
    }

    if (!crypto.integratedGalEnabled) {
        return;
    }

    switch (crypto.type) {
        case IdentityProvider.MsEntra:
            await RefreshMsGraphToken(crypto);
            break;
        default:
            return;
    }
}

async function RefreshMsGraphToken(crypto: iAuth): Promise<any> {
    const graphToken = getLocalValue<iToken>("msGraphToken");
    const expiresAt = GetJwtClaim<number>(graphToken?.access_token, "exp");
    if (expiresAt) {
        let tokenExpiresIn = new Date(expiresAt * 1000).getTime() - new Date().getTime();
        if (tokenExpiresIn >= 10 * 60 * 1000) {
            return; // token is still valid, no need to refresh
        }
    }

    const tokenEndpoint = new URL(crypto.tokenUrl);
    tokenEndpoint.searchParams.append("grant_type", "refresh_token");
    tokenEndpoint.searchParams.append("refresh_token", crypto.token.refresh_token);
    tokenEndpoint.searchParams.append("scope", "https://graph.microsoft.com/.default");

    const hHeaders = new Headers();
    hHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    hHeaders.append("Accept", "application/json");

    var fetchOptions: any = {};
    fetchOptions.method = "POST";
    fetchOptions.headers = hHeaders;
    fetchOptions.body = tokenEndpoint.searchParams;

    let response = await fetch(crypto.tokenUrl, fetchOptions);
    if (response.status !== 200) {
        throw new Error("error");
    }

    var token = await response.json();

    saveLocalValue("msGraphToken", token);
}

export const getRecentTenants = () => {
    const tenants = getLocalValue<iTenants>("RecentTenants");
    return tenants ? tenants.tenants : [];
};

export const saveRecentTenant = (tenant: iTenant) => {
    let tenants = getRecentTenants();
    if (tenants.find(t => t.key == tenant.key)) {
        tenants = tenants.filter(t => t.key != tenant.key);
    }
    tenants.unshift(tenant);
    saveLocalValue("RecentTenants", { tenants: tenants });
};

export const updateRecentTenants = (allowedTenants: iTenant[]) => {
    const recentTenants = getRecentTenants();
    const intersection = recentTenants.filter(
        x => allowedTenants.find(y => y.key === x.key && y.name === x.name) !== undefined,
    );
    saveLocalValue("RecentTenants", { tenants: intersection });
};

export const logout = () => {
    sessionStorage.clear();
    localStorage.removeItem("auth"); // Remove tenant tokens as well.
    store.dispatch({ type: "USER_LOGOUT" });
};

export async function setTenantContext(tenant: iTenant, tenantAuth: iTenantContext) {
    const tenantStore = getSessionValue<iTenant>("tenant");
    if (tenantStore == null) {
        saveSessionValue("tenant", {
            name: tenant.name,
            key: tenant.key,
            token: tenantAuth.token,
            accessToMultipleTenants: false,
            theme: tenantAuth.theme,
            expiresIn: tenant.expiresAt,
        });
    } else {
        tenantStore.name = tenant.name;
        tenantStore.key = tenant.key;
        tenantStore.token = tenantAuth.token;
        tenantStore.theme = tenantAuth.theme;
        tenantStore.expiresAt = tenant.expiresAt;
        saveSessionValue("tenant", tenantStore);
    }

    const permissions = ConstructPermissions(tenantAuth.token);

    const user: iUser = tenantAuth;
    // The STS token response doesn't carry the legacy settings; they come from the profile below.
    user.legacySettings = "";
    const profileResponse = await GetUserProfileData(user.userID);
    if (profileResponse.isOk && profileResponse.data) {
        user.legacySettings = profileResponse.data.legacyUserSettings ?? "";
        let profile = { email: "", jobTitle: "" };
        if (profileResponse.data.profile) {
            profile = JSON.parse(profileResponse.data.profile);
            user.profile = profile;
        }
    }
    user.mailboxes.sort((x, y) => x.name.localeCompare(y.name));
    setLastTouched(user, permissions);

    store.dispatch(setPermissions(permissions));
    store.dispatch(setUser(user));
    store.dispatch(setUserPreferences(getAllPreferences()));
}

function setLastTouched(user: iUser, permissions: iPermissions) {
    let lastTouched = getLastTouched();

    if (lastTouched === undefined || lastTouched === null) {
        lastTouched = {
            SearchResults: {
                ActiveList: "Results",
                EnquiryLists: [
                    {
                        Name: "Results",
                        EnquiryId: 0,
                        CommId: 0,
                    },
                ],
                Pagination: { pageNumber: 1, sortColumn: "", sortAscending: true },
            },
            MyEnquiries: {
                ActiveList: "Unresolved", // what q or resolved or unresolved is open. set this as a default
                EnquiryLists: [
                    {
                        Name: "Unresolved",
                        EnquiryId: 0,
                        CommId: 0,
                    },
                    {
                        Name: "Resolved",
                        EnquiryId: 0,
                        CommId: 0,
                    },
                ],
            },
            MyTeams: {
                ActiveList: "Unresolved", // what q or resolved or unresolved is open. set this as a default
                EnquiryLists: [
                    {
                        Name: "Unresolved",
                        EnquiryId: 0,
                        CommId: 0,
                    },
                    {
                        Name: "Resolved",
                        EnquiryId: 0,
                        CommId: 0,
                    },
                ],
                UserId: 0,
                CalendarUserId: 0,
            },
            Queue: {
                ActiveList: 0,
                EnquiryLists: [],
                Pagination: { pageNumber: 1, sortColumn: "", sortAscending: false },
            },
            lastActiveListType: "",
        };
    }

    const viewableMailboxes = user.mailboxes.filter(x => GetMailboxPermissions(permissions, x.id).ViewEnquiryList);

    const existingEnquiryList = lastTouched.Queue.EnquiryLists;
    lastTouched.Queue.EnquiryLists = [];

    for (const mailbox of viewableMailboxes) {
        const existing = existingEnquiryList.find(x => x.Name === mailbox.id);

        if (existing !== undefined) {
            lastTouched.Queue.EnquiryLists.push(existing);
        } else {
            lastTouched.Queue.EnquiryLists.push({
                Name: mailbox.id,
                EnquiryId: 0,
                CommId: 0,
                Label: mailbox.name + " " + mailbox.reference,
            });
        }
    }

    if (
        !lastTouched.Queue.EnquiryLists.find(x => x.Name === lastTouched.Queue.ActiveList) &&
        lastTouched.Queue.EnquiryLists.length > 0
    ) {
        lastTouched.Queue.ActiveList = lastTouched.Queue.EnquiryLists[0].Name;
    }

    saveLastTouched(lastTouched);
}

let updateAuthTokensInFlight: Promise<any> | null = null;
let updateAuthTokensTimer: number | undefined;

// Concurrent callers (e.g. several API calls getting a 401 at once) share one refresh, so the refresh
// token is redeemed once and only one 55 minute timer chain exists.
export function UpdateAuthTokens(): Promise<any> {
    if (!updateAuthTokensInFlight) {
        updateAuthTokensInFlight = doUpdateAuthTokens().finally(() => {
            updateAuthTokensInFlight = null;
        });
    }
    return updateAuthTokensInFlight;
}

async function doUpdateAuthTokens(): Promise<any> {
    var promise = new Promise<any>(async (resolve, reject) => {
        const worker: Worker = createAuthWorker();
        const crypto = getLocalValue<iAuth>("auth");
        const tenant = getSessionValue<iTenant>("tenant");
        if (!crypto || !tenant) {
            logout();
            worker.terminate();
            reject("error");
            return;
        }
        let data = {
            token: crypto.token.refresh_token,
            tenant: tenant,
            tokenUrl: crypto.tokenUrl,
            STSUrl: getSTSUrl(),
            elevate: getElevateValue() == true ? true : false,
        };
        await worker.postMessage(data);
        worker.onmessage = async event => {
            if (event.data.error == false) {
                saveLocalValue("updateAuthToken", "TokenManger.ts line 357 - " + event.data.data);
                crypto.token = event.data.data;
                saveLocalValue("auth", crypto);
                let tenantContext: iTenantContext = crypto.token.tenantAuth;
                tenant.expiresAt = new Date(parseJwt(tenantContext.token).exp * 1000).getTime();
                setTenantContext(tenant, tenantContext);
                await UpdateConfiguration();
                window.clearTimeout(updateAuthTokensTimer);
                updateAuthTokensTimer = window.setTimeout(UpdateAuthTokens, 55 * 60 * 1000);
                console.log("call to update the tokens");
                worker.terminate();
                resolve("success");
            } else {
                alert("an error occured and token could not be updated - " + event.data.data);
                logout();
                worker.terminate();
                reject("error");
            }
        };
    });
    return promise;
}

export const getActiveTenant = (returnToLower: boolean = true): string => {
    const tenant = getSessionValue<iTenant>("tenant");
    if (tenant) {
        return returnToLower ? tenant.key.toLowerCase() : tenant.key;
    }
    return "";
};

export const getActiveTenantName = (returnToLower: boolean = true): string => {
    const tenant = getSessionValue<iTenant>("tenant");
    if (tenant) {
        return returnToLower ? tenant.name.toLowerCase() : tenant.name;
    }
    return "";
};

export const isTenantValid = (tenant: string) => {
    if (getActiveTenant(true) == tenant.toLowerCase()) {
        return true;
    } else {
        return false;
    }
};

export const getSTSUrl = () => {
    let sURL = process.env.REACT_APP_STS;
    if (!sURL || sURL.length === 0) {
        var str = window.location;
        let stringtoReplaces = str.origin.substring(
            str.protocol.length + 2,
            str.origin.indexOf(".", str.protocol.length + 2),
        );
        sURL = str.origin.replace(stringtoReplaces, "sts");
    }
    if (!sURL.endsWith("/")) {
        sURL += "/";
    }

    return sURL;
};

export function parseJwt(token: string) {
    return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
}

const getTenantContext = async (tenantKey: string): Promise<iTenantContext> => {
    try {
        let crypto = getLocalValue<iAuth>("auth");
        if (!crypto) {
            throw new Error("401");
        }
        return await exchangeIdpToken(crypto!, tenantKey);
    } catch (err: any) {
        if (err == "401" || (err.message && err.message == "401")) {
            await refreshIDPToken();

            try {
                let crypto = getLocalValue<iAuth>("auth");
                localStorage.setItem(
                    "error-logout-auth-token-2",
                    "TokenManger.ts line 434 - " + crypto?.token + " - " + new Date().toString(),
                );
                return await exchangeIdpToken(crypto!, tenantKey);
            } catch (err) {
                // failed to get new tenant token, possible Idp token no longer has access to tenant or user may be blocked. line 436 needs top be removed
                localStorage.setItem(
                    "error-logout",
                    "TokenManger.ts line 436 - " + err + " - " + new Date().toString(),
                );
                window.location.href = window.location.origin;
            }
        } else if (err == "403" || (err.message && err.message == "403")) {
            //line 441 needs top be removed
            localStorage.setItem("error-logout", "TokenManger.ts line 441 - " + err + " - " + new Date().toString());
            window.location.href = window.location.origin;
        }
    }
    throw new Error("");
};

export async function getTenantAccess(tenant: iTenant) {
    if (document.getElementById("loader") != undefined) {
        (document.getElementById("loader") as HTMLElement).style.display = "flex";
    }
    const tenantContext = await getTenantContext(tenant.key);
    let tenantToken = parseJwt(tenantContext.token);
    tenant.expiresAt = new Date(tenantToken.exp * 1000).getTime();
    await setTenantContext(tenant, tenantContext);
    if (tenantContext.mailboxes?.length === 0) window.location.href = window.location.origin + "/unauthorised";

    await UpdateConfiguration();
}
